import { render } from "./MMEditPresident.vue?vue&type=template&id=984d8c38"
import script from "./MMEditPresident.vue?vue&type=script&lang=js"
export * from "./MMEditPresident.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__